import type { WhitelistedPayoutAddress } from '@/services/api/whitelisted-payout-addresses';

interface DeleteAddressSummaryProps {
  address: WhitelistedPayoutAddress;
}

// Rendered inside the confirm dialog's DialogDescription (a <p>) — span-only markup
// keeps the DOM nesting valid while reproducing the legacy content block.
export const DeleteAddressSummary = ({ address }: DeleteAddressSummaryProps) => (
  <span className="flex flex-col gap-3 text-left">
    <span className="font-semibold text-foreground">Are you sure you want to delete this whitelisted payout address?</span>
    <span className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1">
      <span className="font-semibold text-foreground">Name:</span>
      <span>{address.name}</span>
      <span className="font-semibold text-foreground">Type:</span>
      <span>{address.type}</span>
      <span className="font-semibold text-foreground">Currency:</span>
      <span>{address.currency}</span>
      {address.iban ? (
        <>
          <span className="font-semibold text-foreground">IBAN:</span>
          <span className="break-all">{address.iban}</span>
        </>
      ) : null}
      {address.wallet_address ? (
        <>
          <span className="font-semibold text-foreground">Wallet:</span>
          <span className="break-all">{address.wallet_address}</span>
        </>
      ) : null}
    </span>
    <span className="italic">This action cannot be undone.</span>
  </span>
);
DeleteAddressSummary.displayName = 'DeleteAddressSummary';
